module.exports = __webpack_public_path__ + "media/treesudoku4.f5cdc86f.mp4";